/*
Soporte para el "Search" desde hasta
Autor: Benjamín León
Fecha: 2025-01-20
*/

type FilterField<T> = (item: T) => number | null

const filterFromTo = <T>({
  array,
  filterField,
  searchTermFrom,
  searchTermTo,
}: {
  array: T[]
  filterField: FilterField<T>
  searchTermFrom: number | null
  searchTermTo: number | null
}) => {
  // Filter logic
  if (!searchTermFrom && !searchTermTo) return array

  if (searchTermFrom && !searchTermTo) {
    return array.filter((item) => Number(filterField(item)) >= searchTermFrom)
  }

  if (!searchTermFrom && searchTermTo) {
    return array.filter((item) => Number(filterField(item)) <= searchTermTo)
  }

  if (searchTermFrom && searchTermTo) {
    return array.filter(
      (item) => Number(filterField(item)) >= searchTermFrom && Number(filterField(item)) <= searchTermTo
    )
  }

  return []
}

export default filterFromTo
